<template>
  <div>
    <page-header
    color="nm-gradient-1"
      firstLine="Engage A New"
      secondLine="Market"
      keyword="Segment"
      tagline="Not sure where or how to start? No worries. We're gamification experts! Let us transform your marketing experience."
      ></page-header>
    <contact-form
    color="nm-gradient-2"
      title="Get In Touch"
      subtitle="And speak to one of our designers."
      text="Level 8, Vertical Corporate Tower B,Avenue 10, The Vertical,Bangsar South City,No. 8, Jalan Kerinchi,59200 Kuala Lumpur,Malaysia."
      message="Hi NightMorning,

This is [Name] and I'm with [Company]. I’d like to have a game made for the purpose of [insert desired outcome(s)]. We’re hoping to launch it by [insert date], and are wondering how much it would cost.

(optional but really helpful) 
We’re thinking of something like [game name] and [other game name] but [insert plot twist!].

Let’s make something awesome together!

Best Regards,
[Name]
[Number maybe]
[email]"
    ></contact-form>
  </div>
</template>
<script>
import PageHeader from "./components/PageHeader";
import Panel from "./components/DisplayPanel";
import ContactForm from "./components/ContactForm";
export default {
  components: {
    PageHeader,
    Panel,
    ContactForm
  }
};
</script>
